module.exports = {
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
    mode: "cors",
  },
};
